import { render, staticRenderFns } from "./IconUserRemoveSolid.vue?vue&type=template&id=eff2a114"
import script from "./IconUserRemoveSolid.vue?vue&type=script&lang=js"
export * from "./IconUserRemoveSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports